<template>
  <div>
    <BaseButton primary small @click="addProject"> Add Project </BaseButton>
  </div>
</template>

<script>
import { productProjectsClient } from '@/api/clients/admin';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  computed: {
    product() {
      return this.$store.state.entities.products.byId[this.productId] || null;
    },
  },
  methods: {
    addProject() {
      this.$modal.show({
        component: () => import('Components/ProductProjects/ProjectAddModal.vue'),
        props: {
          action: this.storeProject,
          product: this.product,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async storeProject(data) {
      try {
        await productProjectsClient.store(this.productId, mapKeysToSnakeCase(data));

        this.$emit('project-added');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
